import React from "react";
import useModal from "./useModal";
import ModalWrapper from "./ModalWrapper";

let ModalContext;
let { Provider } = (ModalContext = React.createContext());

let ModalProvider = ({ children }) => {
  let { modal, handleModal, modalContent } = useModal();
  return (
    <Provider value={{ modal, handleModal, modalContent }}>
      {children}
      <ModalWrapper />
    </Provider>
  );
};

export { ModalContext, ModalProvider };
